import React from 'react';
import { Lang } from 'shared/constants';
import { Breadcrumbs } from '../../../components/breadcrumbs';
import { ContentList, ContentItem } from '../../../components/content';
import styles from './Knowledge.module.scss';

const KnowledgePageComponent = React.memo(
  ({
    id,
    title,
    children,
    knowledgeItems,
    updatedAt,
    lang,
    lastUpdated,
    fullPath,
    pathParts,
    ownerId,
    tags,
  }) => {
    const renderContent = () => {
      if (knowledgeItems.length) {
        return (
          <ContentItem
            {...{ title, children, knowledgeItems, updatedAt, fullPath, ownerId, tags }}
          />
        );
      }

      return (
        <ContentList
          list={children}
          ownerId={ownerId}
          key={lastUpdated}
          fullPath={fullPath}
          id={id}
          tags={tags}
        />
      );
    };

    return (
      <div className={styles.root}>
        <Breadcrumbs pathParts={pathParts} title={title} />
        {renderContent()}
      </div>
    );
  },
);

KnowledgePageComponent.defaultProps = {
  lang: Lang.HOME_SCREEN,
  list: null,
  isReady: false,
  lastUpdated: Date.now(),
  children: null,
  knowledgeItems: [],
  fullPath: '',
  pathParts: [],
  ownerId: '',
};

export { KnowledgePageComponent };
